<div #background *ngIf="file" class="p-d-flex p-flex-column p-jc-between">
    <div class="preview-button-container p-text-right">
        <button pButton class="p-button-text p-button-rounded p-button-secondary p-button-lg" icon="pi pi-external-link" title="Open in new window" (click)="openInNewWindow()"></button>
        <button pButton class="p-button-text p-button-rounded p-button-secondary p-button-lg" icon="pi pi-times" title="Close" (click)="clearFile()"></button>
    </div>
    <div class="preview-content">
        <lb-file-details [file]="file"
                         [showDownload]="false"
                         [showDetails]="false"
                         preloadMedia="auto"
                         [muted]="false"
                         [autoPlayMedia]="true"
                         (currentTimeChange)="updatePlaybackTime($event)">
        </lb-file-details>
    </div>
    <div></div>
</div>